import { getPublicConfig } from "./getPublicConfig";
import { XOR } from "~/utils/utilityTypes";
import { AccountSidOption, PublicConfig, RuntimeDomainOption } from "~/modules/config";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export const getPublicConfigData = async (
    option: XOR<AccountSidOption, RuntimeDomainOption>
): Promise<PublicConfig> => {
    return getPublicConfig(ContextManager.newInstance())(option);
};
